'use strict';

define('BetSlipWindowAlertsFac',[
        'lodash'
    ],
    function (_) {

        function betSlipWindowAlertsFac() {
            var alerts = [];

            /**
             * Add alert banner.
             * If an id is given, it will ensure that only one error with the
             * same id is displayed
             *
             * @param {Object} options
             * @param {String} [options.id] identifier
             * @param {String} options.type
             * @param {Boolean} options.closeable
             * @param {String} options.message
             *
             * @returns {Number} index of the alert in the array
             */
            function _addAlert(options) {
                if (options.id) {
                    _closeAlertByIdentifier(options.id);
                }

                return alerts.push(options) - 1;
            }

            /**
             * Removes the alert from the array at the given index.
             * @param  {Number} index index of the alert in the array
             */
            function _closeAlert(index) {
                if (index >= 0) {
                    alerts.splice(index, 1);
                }
            }

            /**
             * Removes the alert that matches the given identifier.
             * @param  {String} id identifier
             */
            function _closeAlertByIdentifier(id) {
                var index = _.findIndex(alerts, function(alert) {
                    return alert.id === id;
                });

                _closeAlert(index);
            }

            function _clearAlerts() {
                // This instead of alerts = [] because we don't want to lose the reference.
                // The alerts variable is being returned and referenced outside this factory.
                alerts.splice(0, alerts.length);
            }

            function _clearAlertsExcept(idToKeep) {
                _.remove(alerts, function (alert) {
                    return alert.id !== idToKeep;
                });
            }

            return {
                alerts                      : alerts,
                addAlert                    : _addAlert,
                closeAlert                  : _closeAlert,
                closeAlertByIdentifier      : _closeAlertByIdentifier,
                clearAlerts                 : _clearAlerts,
                clearAlertsExcept           : _clearAlertsExcept
            };
        }

        return betSlipWindowAlertsFac;
    }
);

